import { COMMON_THEME } from './common';
import { AppTheme } from './interfaces';

export const lightTheme: AppTheme = {
  name: 'Light',
  ...COMMON_THEME,
  colors: {
    ...COMMON_THEME.colors,
    background: '#FFFFFF',
    primary: {
      c900: '#FBF9FF',
      c800: '#F1E7FF',
      c700: '#E8D6FF',
      c600: '#D1BAEF',
      c500: '#D48BEE',
      ca500: '#8207E7',
      c400: '#DE3CF2',
      c300: '#746E7B',
      c200: '#8A3196',
      c100: '#552267',
      c050: '#20162C',
    },
    greyscale: {
      c900: '#FFFFFF',
      c800: '#F4F1F5',
      c700: '#DCD7E0',
      c600: '#B8B2BE',
      c500: '#96919B',
      c400: '#746E7B',
      c300: '#524A5C',
      c200: '#40374F',
      c100: '#372F45',
      c050: '#27232C',
    },
    black: '#FFFFFF',
    white: '#1A171E',
  },
  gradients: {
    ...COMMON_THEME.gradients,
    shimmer: 'linear-gradient(to right, rgba(236, 225, 255, 0), rgba(158, 146, 173, 0.2), rgba(236, 225, 255, 0))',
  },
};
